import Amount from '@/types/Amount';

export default class Coupon {

    public couponId: string;
    public couponCode: string;
	public itemId: string;
	public couponDescription: Map<string, string>;
	public amountDiscount: Amount;
	public minimumOrderValueAllowed: Amount;
	public percentageDiscount: number;
	public freeShipping: boolean;
	public startDateTime: Date;
    public endDateTime: Date;

}
